import React, { useState } from "react";
import { diffWords } from "diff";

export default function RevisionModal({ revisionDoc, open, onClose, currentContent }) {
  const [viewMode, setViewMode] = useState("raw"); // "raw" or "diff"

  if (!open || !revisionDoc) return null;

  // Generate diff blocks
  let diffBlocks = [];
  if (viewMode === "diff" && currentContent) {
    diffBlocks = diffWords(revisionDoc.content || "", currentContent || "");
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded shadow-lg p-6 max-w-lg w-full relative">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <h2 className="text-lg font-bold mb-2">
          {revisionDoc.revNumber ? `Rev #${revisionDoc.revNumber}` : "Revision"}
        </h2>
        {/* Toggle Button Group */}
        <div className="flex gap-2 mb-3">
          <button
            className={`px-3 py-1 rounded ${viewMode === "raw" ? "bg-gray-300 font-bold" : "bg-gray-100"}`}
            onClick={() => setViewMode("raw")}
          >
            Raw
          </button>
          <button
            className={`px-3 py-1 rounded ${viewMode === "diff" ? "bg-gray-300 font-bold" : "bg-gray-100"}`}
            onClick={() => setViewMode("diff")}
          >
            Differences
          </button>
        </div>
        {/* Content */}
        {viewMode === "raw" ? (
          <pre
            className="bg-gray-100 p-2 rounded text-sm whitespace-pre-wrap"
            style={{
              maxHeight: "500px",
              overflowY: "auto",
            }}
          >
            {revisionDoc.content}
          </pre>
        ) : (
          <div
            className="bg-gray-100 p-2 rounded text-sm whitespace-pre-wrap"
            style={{
              maxHeight: "500px",
              overflowY: "auto",
            }}
          >
            {diffBlocks.filter(part => part.added || part.removed).length === 0 ? (
              <span className="text-gray-400">No differences found.</span>
            ) : (
              diffBlocks.map((part, idx) =>
                part.added || part.removed ? (
                  <span
                    key={idx}
                    style={{
                      backgroundColor: part.added
                        ? "#d4f7d4"
                        : part.removed
                        ? "#f7d4d4"
                        : "transparent",
                      textDecoration: part.removed ? "line-through" : "none",
                    }}
                  >
                    {part.value}
                  </span>
                ) : null // Hide unchanged text
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
}